<template>
  <div id="app">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0;display: flex " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">关联公司</span>
      </p>
      <!--<p style="padding-right: 2rem;color: #FFFFFF ">删除</p>-->
    </header>
<div class="main" style="">


  <div class="inforName">
    <p class="inforNameTop">企业名称</p>
    <p > <input class="inforNameInput" type="text" v-model="data.name" @blur="bluer()" placeholder="请填写"></p>
    <p class="bindButton" v-if="bluerShow==true"> <input  type="text" v-model="tipsTitle"  ><span class="bind" @click="addBindMyCompany()">绑定</span></p>
  </div>
  <div class="inforName">
    <p class="inforNameTop">企业简称</p>
    <p> <input class="inforNameInput" type="text" v-model="data.short_name"  placeholder="请填写"></p>
  </div>
  <div class="inforName">
    <p class="inforNameTop">企业logo</p>
    <!--<p> <input class="inforNameInput" type="file"></p>-->
    <p class="inforNameInput" ><van-uploader v-model="fileList" :after-read="onRead" type="file" accept="image/*"  multiple /></p>
  </div>
  <div class="inforName">
    <p class="inforNameTop">企业电话</p>
    <p> <input class="inforNameInput" type="text" v-model="data.tel"  placeholder="请填写"></p>
  </div>
  <div class="inforName">
    <p class="inforNameTop">企业邮箱</p>
    <p> <input class="inforNameInput" type="text" v-model="data.email"  placeholder="请填写"></p>
  </div>
  <div class="inforName">
    <p class="inforNameTop">企业网站</p>
    <p> <input class="inforNameInput" type="text" v-model="data.web"  placeholder="请填写"></p>
  </div>
  <div class="inforName">
    <p class="inforNameTop">所在城市</p>
    <p> <input class="inforNameInput" type="text" v-model="data.city"  placeholder="请填写"></p>
  </div>
  <div class="inforName">
    <!--<p class="inforNameTop">公司规模人数</p>-->
    <p class="inforNameTop">
      <van-cell is-link title="公司规模人数" @click="show = true" /></p>
    <p> <input class="inforNameInput" type="text" v-model="text"  placeholder="请填写" readonly="readonly"></p>

    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />

    <!--<p class="inforNameTop">-->
      <!--<van-dropdown-menu direction="up">-->
        <!--<van-dropdown-item v-model="value1" :options="option1" />-->
        <!--&lt;!&ndash;<van-dropdown-item v-model="value2" :options="option2" />&ndash;&gt;-->
      <!--</van-dropdown-menu>-->
    <!--</p>-->
    <!--<p> <input class="inforNameInput" type="text" v-model="data.name"  placeholder="请填写"></p>-->
  </div>
  <div class="inforName">
    <!--<p class="inforNameTop">公司规模人数</p>-->
    <p class="inforNameTop">
      <van-cell is-link title="发展阶段" @click="showf = true" /></p>
    <p> <input class="inforNameInput" type="text" v-model="textf"  placeholder="请填写" readonly="readonly"></p>

    <van-action-sheet v-model="showf" :actions="actions1" @select="onSelectf" />
  </div>
  <div class="inforName">
    <p class="inforNameTop">公司介绍</p>
    <p >
      <textarea style="width: 100%;height: 5rem" v-model="data.desc"></textarea>
    </p>
  </div>
  <div class="inforName">
    <p class="inforNameTop">一句话介绍公司</p>
    <p> <input class="inforNameInput" type="text" v-model="data.one_desc"  placeholder="请填写"></p>
  </div>
  <div class="inforName">
    <p class="inforNameTop">公司领域</p>
    <p> <input class="inforNameInput" type="text" v-model="data.trade"  placeholder="请填写"></p>
  </div>
  <div class="inforName">
    <p class="inforNameTop">详细地址</p>
    <p> <input class="inforNameInput" type="text" v-model="data.address"  placeholder="请填写"></p>
  </div>

</div>
    <div class="button">
      <van-button style="width: 100%;margin: 0 auto" type="primary" @click="addMyCompany()">保存</van-button>

    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'App',
    data() {
      return {
//        transitionName: 'slideleft'
        radio:"",
        tipsTitle:"公司已存在，是否绑定",
        fileList:[
          {url:"http://zpapi.yuexinduo.com/upload/logo/9fbf386a2243fed0b4e12866e2e17e4d.jpg"}
        ],
        data:{
          name:'',
          short_name:'',
          tel:'',
          email:'',
          web:'',
          city:'',
          scale:'',
          stage:'',
          desc:'',
          one_desc:'',
          trade:'',
          address:'',
        },
        name:"1",
        text:'',
        textValue:'',
        textf:'',
        textfValue:'',
        list:'',
        id:'',
         value1: 0,
         value2: 'a',
        show:false,
        showf:false,
        bluerShow:false,
        actions: [{ name: '15人以下',value:1 }, { name: '15-50',value:2 }, { name: '50-150',value:3 },{ name: '150-500',value:4 },{ name: '500-2000',value:5 },{ name: '2000以上',value:6 }],
        actions1: [{ name: '不需要融资',value:1 }, { name: '天使轮',value:2 }, { name: 'A轮',value:3 },{ name: 'B轮',value:4 },{ name: 'C轮',value:5 },{ name: 'D轮及以上',value:6 },{ name: '上市公司',value:7 }],
        option1: [
        { text: '全部商品', value: 0 },
        { text: '新款商品', value: 1 },
        { text: '活动商品', value: 2 },
      ],
      }
    },
    mounted(){
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      bluer(){
        alert(11)
      },
      onRead(file) {
        var formData = new FormData();
        formData.append('image', file.file); //接口需要传的参数
        axios({
            url:"http://zpapi.yuexinduo.com/index/company/uploadLogo",
            method: 'post',
            data: formData,
            processData: false,// 告诉axios不要去处理发送的数据(重要参数)
            contentType: false,
            msg:1,// 告诉axios不要去设置Content-Type请求头
//          headers: {
//          'Content-Type': 'multipart/form-data'}
          }
        ).then((res)=>{
          let src={url:res.data.imgurl}
//          let str = res.response_data[0];
          this.fileList.push(str);//将图片地址存入一个数组中
          console.log(res)
        })
      },
      onSelectf(item){
        this.showf=false;
        this.textf=item.name;
        this.textValue=item.value;

        this.$toast(item.name);
      },
      onSelect(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        this.show = false;
//        Toast(item.name);
        this.text=item.name;
        this.textfValue=item.value;
        this.$toast(item.name);
      },

      addMyCompany(){
        console.log(this.text)
        console.log(this.textf)
        this.$api.addMyCompany(
          {
            'data[name]':this.data.name,
          "data[short_name]": this.data.short_name,
          "data[tel]":  this.data.tel,
          "data[email]":this.data.email,
          "data[web]":this.data.web,
          "data[city]": this.data.city,
          "data[scale]": this.textValue,
          "data[stage]": this.textfValue,
          "data[desc]":this.data.desc,
          "data[one_desc]":this.data.one_desc,
          "data[trade]":this.data.trade,
          "data[address]":this.data.address,
          "userid":localStorage.getItem("userid")
        }
        )
          .then(res=>{
            if(res.status==200){
              this.$toast("保存成功")
              localStorage.setItem("companyId",res.data.company_id)
            }
          })
          .catch(res=>{

          })
      },
      bluer(){/*失焦搜索公司*/
        this.$api.bindMyCompany(
          {name:this.data.name}
        ) .then(res=>{
          if(res.status==200){
            this.bluerShow=true
          }else {
            this.bluerShow=false
          }
        })
          .catch(res=>{

          })
      },
      addBindMyCompany(){

        this.$api.addMyCompany(
          {
            'data[name]':this.data.name,
            "userid":localStorage.getItem("userid")
//            "name":this.data.name,
          }
        )
          .then(res=>{
            if(res.status==200){
              this.$toast("绑定成功")
              this.$router.push("/comMy")
            }
          })
          .catch(res=>{

          })
      },
    }
  }
</script>

<style scoped="">
  header{
    width: 100%;
    height: 85px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .inforName{
    border-bottom: solid 1px #DEDEDE;
  }
  .inforName input{
    border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  .inforNameTop{
   font-size: 13px;
    color: grey;
  }
  .main{
    margin: 85px 0;
  }
  .inforTop{
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 100px;
  }
  .inforImg{
    width: 80px;
    height: 80px;
  }
  .inforImg img{
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
  .inforName{
    width: 90%;
    margin: auto;
    border-bottom: solid 1px #DEDEDE;
  }
  /*.inforName :first-child{*/
  /*color: #DEDEDE;*/
  /*}*/
  .van-cell::after{
    border: 0;
  }
  .inforSix{
    display: flex;
    width: 90%;
    margin: auto;
    border-bottom: solid 1px #DEDEDE;
  }
  .van-cell-group{
    width: 60%;
  }
  .van-cell{
    padding: 10px 0px;

  }
  .button{
    width: 100%;
    position: fixed;
    bottom: 0;
  }
  .bind{
    display: inline-block;
    background: #3CB371;
    width: 50px;
    text-align: center;
    border-radius: 10px;
    color: #ffffff;
  }
  .bindButton{
    display: flex;
    justify-content: space-between;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/myCompany.vue